import { PageNavigationFlex } from '../../../../Shared/CommonStyles/Common.styles';
import { CustomPageNavigation } from '../../../../UiComponentsLibrary/CustomPagination';

interface PaginationProps {
  currentPage: number;
  currentSize: number;
  totalItems: number;
  handlePageChange: (page: number) => void;
}

const Pagination = ({
  currentPage,
  currentSize,
  totalItems,
  handlePageChange,
}: PaginationProps) => {
  return (
    <PageNavigationFlex>
      <CustomPageNavigation
        id="pagination-nav"
        currentPage={currentPage}
        currentSize={currentSize}
        totalItems={totalItems}
        onPageChangeCb={handlePageChange}
      />
    </PageNavigationFlex>
  );
};

export default Pagination;
